module.exports = require("dayjs/locale/es");